import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false, merchantOnly = false }) => {
  const { currentUser } = useAuth();

  // Not logged in — send to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Admin-only page accessed by non-admin — redirect based on their role
  if (adminOnly && currentUser.role !== 'ADMIN') {
    if (currentUser.role === 'MERCHANT') {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // Merchant-only page accessed by non-merchant — redirect based on their role
  if (merchantOnly && currentUser.role !== 'MERCHANT') {
    if (currentUser.role === 'ADMIN') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;